<template>
<transition name="fade">
  <div class="popup_background" v-if="isOpened">
    <div class="popup_content">
      <button @click="$emit('close')" class="close" uk-tooltip="Закрыть"></button>
      <div class="container">
        <slot name="content"></slot>
      </div>      
    </div>
  </div>
</transition>
</template>

<script>
export default {
  props: ['isOpened']  
}
</script>

<style lang="scss" scoped>
.popup_background {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 99;
}
.popup_content {
  box-sizing: border-box;
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  top: 50%;
  left: 50%;  
  transform: translate(-50%, -50%);  
  background-color: #fff;  
  border-radius: 8px;
  z-index: 11;   
}
.container {
  max-height: 80vh;
  padding: 40px 30px;
  background-color: #fff;    
  border-radius: 8px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

@media (max-width: 640px) {
  .container {
    padding: 30px 15px;
  }
}
</style>